import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./salary.css";

export default function PaidTeacherSalary() {

  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  // Default current month
  const today = new Date();
  const currentMonth = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}`;

  const [month, setMonth] = useState(currentMonth);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);


  /* ================= LOAD PAID SALARIES ================= */

  const loadPaid = async () => {

    try {

      setLoading(true);

      const res = await API.get(
        "/school-admin/salary/paid/",
        {
          headers: {
            "X-SCHOOL-ID": school.school.id,
          },
          params: {
            month: month, // ✅ filter by month
          }
        }
      );

      setList(res.data || []);

    } catch (err) {

      console.error("Failed to load paid salaries", err);
      alert("Failed to load paid salaries");

    } finally {

      setLoading(false);

    }

  };


  /* ================= UNDO PAYMENT ================= */

  const undoPaid = async (salaryId) => {

    if (!window.confirm("Undo this salary payment?")) return;

    try {

      await API.post(
        `/school-admin/salary/undo-paid/${salaryId}/`,
        {
          month: month // ✅ undo only for this month
        },
        {
          headers: {
            "X-SCHOOL-ID": school.school.id,
          },
        }
      );

      loadPaid();

    } catch (err) {

      console.error(err);
      alert("Failed to undo payment");

    }

  };


  /* ================= INITIAL LOAD ================= */

  useEffect(() => {

    loadPaid();

  }, [month]); // reload when month changes


  return (

    <div className="salary-container">

      {/* ================= HEADER ================= */}

      <div className="salary-header">

        <h2 className="page-title">
          Paid Teacher Salaries
        </h2>

        {/* MONTH FILTER */}

        <div className="salary-filter">

          <label>Select Month</label>

          <input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />

        </div>

      </div>


      {/* ================= TABLE ================= */}

      <table className="salary-table">

        <thead>

          <tr>
            <th>Teacher</th>
            <th>Month</th>
            <th>Amount</th>
            <th>Paid On</th>
           
          </tr>

        </thead>

        <tbody>

          {/* Loading */}

          {loading && (

            <tr>
              <td colSpan="5" className="no-data">
                Loading salaries...
              </td>
            </tr>

          )}

          {/* No Data */}

          {!loading && list.length === 0 && (

            <tr>
              <td colSpan="5" className="no-data">
                No paid salaries for this month
              </td>
            </tr>

          )}

          {/* Data */}

          {!loading &&

            list.map((item) => (

              <tr key={item.id}>

                <td>{item.teacher_name}</td>

                <td>
                  {item.month} {item.year}
                </td>

                <td className="salary-amount">
                  ₹{item.salary}
                </td>

                <td>{item.payment_date}</td>

               

              </tr>

            ))

          }

        </tbody>

      </table>

    </div>

  );

}